import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import SiteConfigForm from '../../../components/siteadmin/SiteConfigForm/SiteConfigForm';
import Loader from '../../../components/Loader/Loader';
import { withQuery } from '../../../hoc/withGraphql';
import { configSettings } from '../../../lib/graphql';
import { decode } from '../../../helpers/queryEncryption';
import { censorWord } from '../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import s from './SiteConfiguration.css';
class SiteConfiguration extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      siteSettings: PropTypes.array,
    })
  };

  static defaultProps = {
    data: {
      loading: true
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      isRestrict: false,
    };
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }

  render() {
    const { data: { loading, siteSettings } } = this.props;
    const { isRestrict } = this.state;

    let settingsCollection = {};
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      siteSettings.map((item, key) => {
        if (item.name == 'paypalHost') settingsCollection[item.name] = decode(item.encryptValue);
        else settingsCollection[item.name] = isRestrict ? censorWord(decode(item.encryptValue)) : decode(item.encryptValue)
      });
      return <SiteConfigForm initialValues={settingsCollection} />
    }
  }

}

const mapState = state => ({});

const mapDispatch = {
  demoRestrictionEncode
};

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch),
  withQuery(configSettings,
    {
      options: (props) => ({
        variables: {
          type: 'config_settings',
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(SiteConfiguration);
